import { Component, Input } from '@angular/core';
import { Rodeo } from '../../../../../model/rodeo';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { RodeoService } from '../../../../../services/rodeo.service';
import { LoadingController, ToastController } from 'ionic-angular';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { BackNumberConfig } from '../../../../../model/back-number-config';
import { BackNumber } from '../../../../../model/back-number';
import { AccountHelper } from '../../../../../lib/accountHelper';
import { E } from '@angular/core/src/render3';

@Component({
    selector: 'staff-backnumbers',
    templateUrl: 'backnumbers.component.html'
})
export class BackNumberSection {
    @Input() set rodeo(rodeo: Rodeo) {
        this._rodeo = rodeo;
        this.setDisplays();
        this.filterResults();
    }
    
    get rodeo() {
        return this._rodeo;
    }
    
    _rodeo: Rodeo;

    @Input() disciplines: string[];

    accountIdNames: Map<number, string>;
    horseIdNames: Map<number, string>;

    filterName: string;
    backNumberResults: any[] = [];

    accountHelper: AccountHelper = AccountHelper.instance();

    popoverActive: boolean = false;

    constructor(private rodeoService: RodeoService, private loadingControl: LoadingController, private toast: ToastController
        ,private alert: AlertMessager) {

    }

    filterResults() {
        this.backNumberResults = this.rodeo.backNumbers;        

        if (this.filterName && this.filterName.length != 0)
            this.backNumberResults = this.backNumberResults.filter(x => x.accountName.toLowerCase().indexOf(this.filterName.toLowerCase()) != -1 || x.horseName.toLowerCase().indexOf(this.filterName.toLowerCase()) != -1);
    }

    drawBackNumbers(backNumberConfig: BackNumberConfig) {
        if (this.popoverActive)
            return;

        let loading = this.loadingControl.create({
            content: 'Assigning back numbers...',
        });

        loading.present();

        this.rodeoService.drawBackNumbers(this.rodeo.id, backNumberConfig.eventType)
            .then(data => {
                loading.dismiss();
                this.rodeo.backNumbers = data as BackNumber[];
                this.popoverActive = false;
                this.toast.create({
                    message: "Back numbers assigned!",
                    duration: 3000,
                    position: 'middle',
                }).present();
            }, error => {
                loading.dismiss();
                this.alert.showError("Back number Error", error);
                this.popoverActive = false;
            });
    }

    private setDisplays() {
        var allEntries = this.rodeo.rodeoEvents.flatMap(x => x.registrations);

        this.rodeo.backNumbers.forEach(backNumber => {
            if (backNumber.accountId) {
                var matchingEntry = allEntries.filter(x => x.contestantOneId == backNumber.accountId)[0];

                if (!matchingEntry) {
                    matchingEntry = allEntries.filter(x => x.contestantTwoId == backNumber.accountId)[0];
                    backNumber.accountName = `${matchingEntry.contestantTwo.lastName}, ${matchingEntry.contestantTwo.firstName}`;
                } else
                    backNumber.accountName = `${matchingEntry.contestantOne.lastName}, ${matchingEntry.contestantOne.firstName}`;
            } else if (backNumber.horseId) {
                var matchingEntry = allEntries.filter(x => x.horseOne && x.horseOne.id == backNumber.horseId)[0];

                if (matchingEntry) {
                    backNumber.horseName = matchingEntry.horseOne.name;
                    backNumber.accountName = `${matchingEntry.contestantOne.lastName}, ${matchingEntry.contestantOne.firstName}`;
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/backnumbers/backnumbers.component.ts